import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { PhoneIphone as PhoneIphoneIcon } from "../icons";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

// En la app de iOS no se venden planes, destacados ni tiendas (Apple exige su
// sistema de pagos para lo digital, ver isIOSApp). Sin links ni indicaciones
// para pagar por otro lado: Apple tampoco lo permite.
const IOSPurchaseUnavailable = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        px: 3,
      }}
    >
      <PhoneIphoneIcon sx={{ fontSize: 56, color: brandColors.textSecondary }} />
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        <T>No disponible en la app para iPhone</T>
      </Typography>
      <Typography sx={{ color: brandColors.textSecondary, maxWidth: 360 }}>
        <T>Esta función no está disponible en la app para iPhone.</T>
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)}>
        <T>Volver</T>
      </Button>
    </Box>
  );
};

export default IOSPurchaseUnavailable;
